import noop from 'lib/util/noop/action'
import index from './action/index'

export default {
  index,
  acl: noop,
  noContext: noop,
}
